export const VERTICAL_TABLE_EVENT_ATTRIBUTES = {
  preventColClick: "vt_prevent_col_click",
};
